import { useQuery } from "@tanstack/react-query";
import { getClinic } from "@/lib/dentiumApi";

export const useClinic = () => {
  const { data } = useQuery({ queryKey: ["clinic"], queryFn: getClinic, staleTime: 60000 });
  return data || { name: "", city: "", phone: "", address: "", email: "" };
};
